import { ApiResource } from '@/core/models/ApiResource.interface';
import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Certificate, CertificateDTO } from './certificate.interface';
import { CertificateService } from './certificate.service';

const service = new CertificateService();

export interface CertificateState {
   certificatesOverview?: ApiResource<Array<Certificate>>;
}

const CertificateStore: Module<CertificateState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_CERTIFICATES_OVERVIEW(state, overview: ApiResource<Array<Certificate>>) {
         state.certificatesOverview = overview;
      },
      ADD_CERTIFICATE(state, certificate: Certificate) {
         state.certificatesOverview?.data.push(certificate);
      },
      REMOVE_CERTIFICATE(state, certificateId: number) {
         const index = (state.certificatesOverview?.data || []).findIndex((c) => c.id === certificateId);
         if (index > -1) state.certificatesOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getCertificates(context, payload: { employeeId: number; query?: LocationQuery }) {
         const response = await service.getCertificates(payload.employeeId, payload.query);
         context.commit('SET_CERTIFICATES_OVERVIEW', response);
         return response;
      },
      async createCertificate(context, payload: { employeeId: number; certificateDTO: CertificateDTO }) {
         const response = await service.postCertificate(payload.employeeId, payload.certificateDTO);
         context.commit('ADD_CERTIFICATE', response);
         return response;
      },
      async deleteCertificate(context, payload: { employeeId: number; certificateId: number }) {
         const response = await service.deleteCertificate(payload.employeeId, payload.certificateId);
         context.commit('REMOVE_CERTIFICATE', payload.certificateId);
         return response;
      },
   },
};

export default CertificateStore;
